import React from "react";
import { useCruise } from "../context/CruiseContext";
import { BedDouble, MapPin, Plane, Check, Info, ExternalLink, Tag } from "lucide-react";
import { Button } from "./ui/button";

const Hotel = () => {
  const { HOTEL } = useCruise();
  const h = HOTEL;
  return (
    <section id="hotel" className="relative bg-[#0A0A0A] py-24">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          {/* Image */}
          <div className="relative overflow-hidden rounded-2xl min-h-[320px] group">
            <img
              src={h.image}
              alt={h.name}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/20 to-transparent" />
            <div className="absolute top-4 left-4">
              <span className="inline-flex items-center gap-2 bg-[#E50914] text-white font-cond uppercase text-[11px] font-bold tracking-widest px-3 py-1.5">
                <BedDouble size={14} /> Host Hotel
              </span>
            </div>
            <div className="absolute bottom-0 left-0 p-6">
              <div className="flex items-center gap-2 text-[var(--hh-gold)] mb-1">
                <MapPin size={16} />
                <span className="font-cond uppercase text-xs tracking-widest">{h.location}</span>
              </div>
              <h3 className="font-display uppercase text-white text-4xl">{h.name}</h3>
            </div>
          </div>

          {/* Content */}
          <div className="flex flex-col justify-center">
            <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">Before You Board</p>
            <h2 className="font-display uppercase text-white text-3xl sm:text-5xl leading-[0.95]">
              {h.tagline}
            </h2>
            <div className="flex items-center mt-4 mb-6">
              <span className="section-line" />
            </div>
            <p className="text-white/75 text-lg">{h.intro}</p>

            <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {h.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#1B8A5A] text-white shrink-0 mt-0.5">
                    <Check size={14} />
                  </span>
                  <span className="text-white/85 text-sm">{b}</span>
                </li>
              ))}
            </ul>

            <div className="mt-7 flex items-start gap-3 bg-[#1A1A1A] border-l-4 border-[var(--hh-gold)] p-4">
              <Info size={18} className="text-[var(--hh-gold)] mt-0.5 shrink-0" />
              <p className="text-white/65 text-sm">{h.note}</p>
            </div>

            <div className="mt-6 flex items-center gap-2 text-white/50">
              <Plane size={16} className="text-[#E50914]" />
              <span className="font-cond uppercase text-xs tracking-widest">
                {h.arrivalNote || "Fly into San Juan (SJU) • Arrive by Dec 3"}
              </span>
            </div>

            {h.bookingUrl && (
              <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-4">
                <a href={h.bookingUrl} target="_blank" rel="noopener noreferrer" data-testid="hotel-booking-btn">
                  <Button className="bg-[var(--hh-gold)] hover:opacity-90 text-[#0A0A0A] font-cond font-bold uppercase tracking-widest rounded-full px-7 h-12 w-full sm:w-auto">
                    {h.bookingLabel || "Reserve Hotel"}
                    <ExternalLink size={16} className="ml-2" />
                  </Button>
                </a>
                {h.groupCode && (
                  <div className="inline-flex items-center gap-2 bg-[#1A1A1A] border border-white/15 rounded-full px-4 py-2.5">
                    <Tag size={14} className="text-[var(--hh-gold)]" />
                    <span className="font-cond uppercase text-xs tracking-widest text-white/60">Group Code</span>
                    <span className="font-cond font-bold uppercase text-white tracking-widest">{h.groupCode}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hotel;
